export namespace VdzFormHelper {
  export const assetPath = 'assets/pdfs/vdz_form.pdf';

  export const downloadFilename = 'vdz-formular-hydraulischer-abgleich.pdf';

  export enum VdzFormStatus {
    Loading = 'loading',
    Ready = 'ready',
    Error = 'error',
  }

  export enum VdzFieldType {
    PDFCheckBox = 'PDFCheckBox',
    PDFSignature = 'PDFSignature',
    PDFTextField = 'PDFTextField',
  }

  // String value taken directly from .pdf
  export type VdzFieldName =
    | 'Dokumentation inkl. Berechnungsergebnisse erhalten'
    | 'differenzdruckregler heizkreis 1'
    | 'differenzdruckregler heizkreis 2'
    | 'differenzdruckregler heizkreis 3'
    | 'durchflussregler heizkreis 1'
    | 'durchflussregler heizkreis 2'
    | 'durchflussregler heizkreis 3'
    | 'Unterschrift Antragsteller'
    | 'Unterschrif Fachbetrieb'
    | 'Ort, Datum Fachbetrieb'
    | 'Ort, Datum Antragsteller'
    | 'Bemerkungen'
    | 'heizkreis 1 Zweirohrheizung'
    | 'heizkreis 1 Fußbodenheizung'
    | 'heizkreis 1 Einrohrheizung'
    | 'heizkreis 2 Einrohrheizung'
    | 'heizkreis 2 Fußbodenheizung'
    | 'heizkreis 2 Zweirohrheizung'
    | 'heizkreis 3 Einrohrheizung'
    | 'heizkreis 3 Fußbodenheizung'
    | 'heizkreis 3 Zweirohrheizung'
    | 'Ausdehnungsgefäß geprüft'
    | 'A'
    | 'B'
    | 'Heizkreis 1 Auslegungsvorlauftemperatur'
    | 'Heizkreis 1 Heizkreisrücklauftemperatur'
    | 'Heizkreis 1 Gesamtdurchfluss'
    | 'Heizkreis 1 Pumpenförderhöhe'
    | 'Heizkreis 2 Auslegungsvorlauftemperatur'
    | 'Heizkreis 2 Heizkreisrücklauftemperatur'
    | 'Heizkreis 2 Gesamtdurchfluss'
    | 'Heizkreis 2 Pumpenförderhöhe'
    | 'Heizkreis 3 Pumpenförderhöhe'
    | 'Heizkreis 3 Auslegungsvorlauftemperatur'
    | 'Heizkreis 3 Heizkreisrücklauftemperatur'
    | 'Heizkreis 3 Gesamtdurchfluss'
    | 'Fülldruck bar'
    | 'Name Antragsteller'
    | 'Straße Nummer Antragsteller'
    | 'PLZ Ort Antragsteller'
    | 'Objektanschrift Zeile 1'
    | 'Objektanschrift Zeile 2';

  export const vdzFields: { type: VdzFieldType; name: VdzFieldName }[] = [
    { type: VdzFieldType.PDFCheckBox, name: 'Dokumentation inkl. Berechnungsergebnisse erhalten' },
    { type: VdzFieldType.PDFCheckBox, name: 'differenzdruckregler heizkreis 1' },
    { type: VdzFieldType.PDFCheckBox, name: 'differenzdruckregler heizkreis 2' },
    { type: VdzFieldType.PDFCheckBox, name: 'differenzdruckregler heizkreis 3' },
    { type: VdzFieldType.PDFCheckBox, name: 'durchflussregler heizkreis 1' },
    { type: VdzFieldType.PDFCheckBox, name: 'durchflussregler heizkreis 2' },
    { type: VdzFieldType.PDFCheckBox, name: 'durchflussregler heizkreis 3' },
    { type: VdzFieldType.PDFSignature, name: 'Unterschrift Antragsteller' },
    { type: VdzFieldType.PDFSignature, name: 'Unterschrif Fachbetrieb' },
    { type: VdzFieldType.PDFTextField, name: 'Ort, Datum Fachbetrieb' },
    { type: VdzFieldType.PDFTextField, name: 'Ort, Datum Antragsteller' },
    { type: VdzFieldType.PDFTextField, name: 'Bemerkungen' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 1 Zweirohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 1 Fußbodenheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 1 Einrohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 2 Einrohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 2 Fußbodenheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 2 Zweirohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 3 Einrohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 3 Fußbodenheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'heizkreis 3 Zweirohrheizung' },
    { type: VdzFieldType.PDFCheckBox, name: 'Ausdehnungsgefäß geprüft' },
    { type: VdzFieldType.PDFCheckBox, name: 'A' },
    { type: VdzFieldType.PDFCheckBox, name: 'B' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 1 Auslegungsvorlauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 1 Heizkreisrücklauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 1 Gesamtdurchfluss' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 1 Pumpenförderhöhe' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 2 Auslegungsvorlauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 2 Heizkreisrücklauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 2 Gesamtdurchfluss' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 2 Pumpenförderhöhe' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 3 Pumpenförderhöhe' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 3 Auslegungsvorlauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 3 Heizkreisrücklauftemperatur' },
    { type: VdzFieldType.PDFTextField, name: 'Heizkreis 3 Gesamtdurchfluss' },
    { type: VdzFieldType.PDFTextField, name: 'Fülldruck bar' },
    { type: VdzFieldType.PDFTextField, name: 'Name Antragsteller' },
    { type: VdzFieldType.PDFTextField, name: 'Straße Nummer Antragsteller' },
    { type: VdzFieldType.PDFTextField, name: 'PLZ Ort Antragsteller' },
    { type: VdzFieldType.PDFTextField, name: 'Objektanschrift Zeile 1' },
    { type: VdzFieldType.PDFTextField, name: 'Objektanschrift Zeile 2' },
  ];

  export interface VdzFormHeatingCircuitValues {
    max1: number;
    max2: number;
    max3: number;
    hc1Lowered: number;
    hc2Lowered: number;
    hc3Lowered: number;
  }

  export const annotationText =
    'Der hydraulische Abgleich wurde automatisch mit dem TÜV-zertifizierten System “ViCare Smart Climate” (Registrier-Nr. 268104628) durchgeführt. Alle Radiatoren und/oder Fußbodenverteiler im Haus sind mit ViCare Smart Climate Komponenten ausgestattet';

  export interface VdzFormMappedData {
    name: string;
    address: string;
    waterPressure: number;
    maxFlowTemperatureArray: number[];
    hcTemperaturesLoweredArray: number[];
    volumetricFlow: number;
  }
}
